module.exports = __webpack_public_path__ + "static/media/Upload.c1214768.svg";